import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="page-title"
export default class extends Controller {
  connect() {
    document.addEventListener("turbo:load", this.updateTitle);
    this.updateTitle();
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.updateTitle);
  }

  updateTitle = () => {
    let path = window.location.pathname.replace(/^\//, "");

    if (path === "") {
      document.title = "Home | Lnp Mrs";
      return;
    }

    const deviseTitles = {
      UserLogin: "Login",
      ChangePassword: "Change Password",
      EditPassword: "Update Password",

      "users/password/new": "Forgot Password",
      "users/password/edit": "Reset Password",
      "users/confirmation/new": "Confirm Account",
      "users/unlock/new": "Unlock Account",
    };

    if (deviseTitles[path]) {
      document.title = `${deviseTitles[path]} | Lnp Mrs`;
      return;
    }

    let parts = path.split("/");

    // Remove numeric segments (IDs)
    parts = parts.filter((p) => !/^\d+$/.test(p));

    // Titleize and clean up
    parts = parts.map((p) => this.titleize(p));

    let title = parts.join(" | ");
    document.title = `${title} | Lnp Mrs`;
  };

  titleize(str) {
    return str.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  }
}
